import { render, staticRenderFns } from "./ReceivablesAging.vue?vue&type=template&id=3ca6825a&scoped=true"
import script from "./ReceivablesAging.vue?vue&type=script&lang=js"
export * from "./ReceivablesAging.vue?vue&type=script&lang=js"
import style0 from "./ReceivablesAging.vue?vue&type=style&index=0&id=3ca6825a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca6825a",
  null
  
)

export default component.exports